<template>
  <b-overlay
    id="overlay-background"
    :show="loader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="4"
        lg="4"
        offset-lg="3"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <validation-observer
                ref="settingsform"
                tag="form"
              >
                <b-row>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Calculate Interest"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_CALCULATE_INTEREST')"
                        label-for="default-default"
                      >
                        <v-select
                          v-model="interest_values.calculate_interest"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="calculateInterestOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-default"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Statement"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_STATEMENT')"
                        label-for="default-default"
                      >
                        <v-select
                          v-model="interest_values.interest_statement"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="statementOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-default"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      block
                      variant="primary"
                      @click="postSettingValues"
                    >
                      Save
                    </b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-form>
            <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
    statementValues: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      calculateInterestOptions: [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 },
      ],
      daStatementOptions: [],
      enStatementOptions: [],
      statementOptions: [],
      loader: false,
      required,
      interest_values: {
        calculate_interest: '',
        interest_statement: '',
      },
    }
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.statementOptions = i18n.locale === 'en' ? this.enStatementOptions : this.daStatementOptions
      },
      // You can run any additional logic here when language changes
    },
    statementValues: {
      handler() {
        this.mapStatementValues()
      },
    },
    settings: {
      handler() {
        this.mapValues()
      },
    },
  },
  created() {
  },
  methods: {
    mapValues() {
      Object.keys(this.interest_values).forEach(element => {
        const item = this.settings.filter(word => word.key === element)
        if (item.length > 0) {
          this.interest_values[element] = Number(item[0].value)
        }
      })
    },
    mapStatementValues() {
      this.statementOptions = this.statementValues
      this.statementOptions.forEach(element => {
        const daObj = {
          value: element.id,
          label: `${element.key} - ${element.da_name}`,
        }
        const enObj = {
          value: element.id,
          label: `${element.key} - ${element.en_name}`,
        }
        this.daStatementOptions.push(daObj)
        this.enStatementOptions.push(enObj)
      })
      this.statementOptions = i18n.locale === 'en' ? this.enStatementOptions : this.daStatementOptions
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.loader = true
            const obj = [
              {
                key: 'calculate_interest',
                value: this.interest_values.calculate_interest,
              },
              {
                key: 'interest_statement',
                value: this.interest_values.interest_statement,
              },
            ]
            axios.post('user-settings/save', obj).then(response => {
              if (response.status) {
                this.loader = false
                this.makeSuccessToast()
              }
            }).catch(error => {
              // if (err.response.data.message) {
              //   this.alertErrors.push(err.response.data.message)
              // }
              this.makeFailureToast(error)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .spinner-border{
    width: 6rem;
    height: 6rem;
  }
  </style>
